import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { EApprovedFromAssociation } from '../../../../models/user/UserInfosModel';
import { Box, IconButton, MenuItem, Select, FormControl, SelectChangeEvent } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { GREEN_LOGO } from '../../../../theme/colors';
import { GREEN_MAIN } from '../../../../theme/colors';
import { alpha } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { BLUE_LIGHT_RGB_BORDER } from '../../../../theme/colors';

interface AssociationApprovalsProps {
    approvedFromAssociation: number;
    approvedFromAssociationReset: number;
    handleChange: (value: string, key: string) => void;
    viewButtonReset?: boolean;
}

const AssociationApproval: React.FC<AssociationApprovalsProps> = ({ approvedFromAssociation, approvedFromAssociationReset, handleChange, viewButtonReset = true }) => { 
    const { t } = useTranslation();
    const [selectedValue, setSelectedValue] = React.useState<number>(approvedFromAssociation);
    
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        setSelectedValue(Number(value));
        handleChange(value, 'approvedFromAssociation');
    };
    
    const handleReset = () => {
        setSelectedValue(approvedFromAssociationReset);
        handleChange(approvedFromAssociationReset.toString(), 'approvedFromAssociation');
    };

    const theme = useTheme();

    return (
        <Box sx={{display:'flex'}}>
            <FormControl fullWidth>
                <Select
                    value={selectedValue.toString()}
                    onChange={handleSelectChange}
                    disabled={selectedValue === 1}
                    sx={{
                        marginBottom: 0,
                        marginTop: 0,
                        height: '45px',
                        '& .MuiOutlinedInput-notchedOutline': {
                            color: GREEN_MAIN,
                        },
                        '& .MuiSelect-select': {
                            padding: '12px 12px',
                            lineHeight: 1.4,
                            color: "grey",
                            fontSize: '1rem',
                            textTransform: 'none'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: GREEN_LOGO,
                            color: GREEN_MAIN,
                        },
                        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'grey !important',
                        }
                    }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                '& .MuiMenuItem-root': {
                                    fontSize: '1rem',
                                    color: GREEN_MAIN,
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 128, 0, 0.08)'
                                    },
                                    '&.Mui-selected': {
                                        backgroundColor: 'rgba(0, 128, 0, 0.12)',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 128, 0, 0.16)'
                                        }
                                    }
                                }
                            }
                        }
                    }}
                >
                    {Object.keys(EApprovedFromAssociation).map((key) => {
                        const typedKey = key as keyof typeof EApprovedFromAssociation;
                        if (isNaN(Number(typedKey))) {
                            const value = EApprovedFromAssociation[typedKey];
                            const displayValue = value === 0 ? 0 : value;
                            
                            if (selectedValue === 0 && value === 1) {
                                return (
                                    <MenuItem key={typedKey} value={displayValue}>
                                        {t(typedKey)}
                                    </MenuItem>
                                );
                            }
                            if (selectedValue === 1 && value === 1) {
                                return (
                                    <MenuItem key={typedKey} value={displayValue}>
                                        {t(typedKey)}
                                    </MenuItem>
                                );
                            }
                            if (selectedValue === 0 && value === 0) {
                                return (
                                    <MenuItem key={typedKey} value={displayValue}>
                                        {t(typedKey)}
                                    </MenuItem>
                                );
                            }
                        }
                        return null;
                    })}
                </Select>
            </FormControl>

            {viewButtonReset && (
                <Box sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <IconButton onClick={handleReset} sx={{ 
                        width:'45px', 
                        height:'45px',
                        color: GREEN_MAIN
                    }}>
                        <ClearIcon />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
}

export default AssociationApproval;